import React, { useState } from 'react';
import CruiseHighlights from './Highlights';
import Renderads from './advertisement';

const RenderCruisePage = ({ onSubmit }) => {
  const [cruisePort, setCruisePort] = useState('');
  const [cruiseLine, setCruiseLine] = useState('');
  const [adultCount, setAdultCount] = useState(1);
  const [childCount, setChildCount] = useState(0);
  const [infantCount, setInfantCount] = useState(0);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit({ cruisePort, cruiseLine, adultCount, childCount, infantCount });
    }
  };

  return (
    <div className="w-full">
      <Renderads imgNumber={1} />

      <div className="bg-gradient-to-br from-[#EBFFF7] via-[#F4FEFF] to-[#EFFFF7] py-10 px-4">
        <div className="max-w-6xl mx-auto">
          <form
            onSubmit={handleSubmit}
            className="w-full flex flex-wrap md:flex-nowrap gap-4 md:gap-5 items-end 
            bg-white/95 border border-teal-100 shadow-lg rounded-3xl p-6 md:p-8 backdrop-blur-sm"
          >
            {/* Departure Port */}
            <div className="w-full md:w-[22%]">
              <label className="text-sm text-gray-600 font-semibold mb-1 block">
                Departure Port
              </label>
              <input
                type="text"
                value={cruisePort}
                onChange={(e) => setCruisePort(e.target.value)}
                placeholder="Miami, FL"
                className="border border-gray-300 rounded-xl px-4 py-3 w-full 
                focus:border-teal-500 focus:ring-2 focus:ring-teal-200 transition"
                required
              />
            </div>

            {/* Cruise Line */}
            <div className="w-full md:w-[22%]">
              <label className="text-sm text-gray-600 font-semibold mb-1 block">
                Cruise Line
              </label>
              <input
                type="text"
                value={cruiseLine}
                onChange={(e) => setCruiseLine(e.target.value)}
                placeholder="Royal Caribbean"
                className="border border-gray-300 rounded-xl px-4 py-3 w-full 
                focus:border-teal-500 focus:ring-2 focus:ring-teal-200 transition"
                required
              />
            </div>

            {/* Adults */}
            <div className="w-full md:w-[12%]">
              <label className="text-sm text-gray-600 font-semibold mb-1 block">
                Adults
              </label>
              <input
                type="number"
                value={adultCount}
                min={1}
                onChange={(e) => setAdultCount(Number(e.target.value))}
                className="border border-gray-300 rounded-xl px-4 py-3 w-full 
                focus:border-teal-500 focus:ring-2 focus:ring-teal-200 transition"
                required
              />
            </div>

            {/* Children */}
            <div className="w-full md:w-[12%]">
              <label className="text-sm text-gray-600 font-semibold mb-1 block">
                Children
              </label>
              <input
                type="number"
                value={childCount}
                min={0}
                onChange={(e) => setChildCount(Number(e.target.value))}
                className="border border-gray-300 rounded-xl px-4 py-3 w-full 
                focus:border-teal-500 focus:ring-2 focus:ring-teal-200 transition"
                required
              />
            </div>

            {/* Infants */}
            <div className="w-full md:w-[12%]">
              <label className="text-sm text-gray-600 font-semibold mb-1 block">
                Infants
              </label>
              <input
                type="number"
                value={infantCount}
                min={0}
                onChange={(e) => setInfantCount(Number(e.target.value))}
                className="border border-gray-300 rounded-xl px-4 py-3 w-full 
                focus:border-teal-500 focus:ring-2 focus:ring-teal-200 transition"
                required
              />
            </div>

            {/* Search Button */}
            <div className="w-full md:w-[12%] min-w-[120px]">
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-orange-500 to-pink-500 
                text-white py-3 px-4 rounded-xl font-semibold shadow-md 
                hover:shadow-lg hover:scale-[1.02] transition-transform"
              >
                Search
              </button>
            </div>
          </form>
        </div>
      </div>

      <CruiseHighlights />
    </div>
  );
};

export default RenderCruisePage;
